const context = '@@language'
import store from '@/store'

// 点击
function handleClick(el, binding) {
  function handle(e) {
    const language = binding.value || 'zh-CN'
    store.dispatch('pageInfo/setLanguage', language)
  }
  if (!el[context]) {
    el[context] = {
      removeHandle: handle
    }
  } else {
    el[context].removeHandle = handle
  }
  return handle
}

export default {
  bind(el, binding) {
    el.addEventListener('click', handleClick(el, binding), false)
  },
  unbind(el) {
    el.removeEventListener('click', el[context].removeHandle, false)
    el[context] = null
    delete el[context]
  }
}



// WEBPACK FOOTER //
// ./src/directive/language/language.js